const QUERY_TOTE_CART = `
query QueryWebToteCart {
    me {
      tote_cart {
        id
        state
        nth_tote        
        max_clothing_count
        max_accessory_count
        clothing_bonus_slots_sum
        accessory_bonus_slots_sum
        express_fulfillment_center_config {
          open_change_express
          popup_change_express_banner_url
          tips
        }
        accessory_items {
          ...toteCartItemFields
        }
        clothing_items {
          ...toteCartItemFields
        }
        premium_clothing_slot_count
        premium_accessory_slot_count
        premium_service {
          max_purchase_clothing_slot
          max_purchase_accessory_slot
          clothing_slot_price
          accessory_slot_price
          origin_clothing_slot_price
          origin_accessory_slot_price
        }
        has_replaced_product
        display_more_product_entry
        with_free_service
        used_free_service
        disable_free_service
        display_free_service_banner
        disable_coupon
        accessory_customer_coupon {
          customer_coupon_id
          slot_count
        }
        clothing_customer_coupon {
          customer_coupon_id
          slot_count
        }        
        onboarding
        tote_cart_bottom_tips
        banner {
          url
        }
        popup {
          url
        }
        validate_result_v1(
          category_rule_flag: true
          need_category_rule_verify: true
        ) {
          errors {
            error_code
            message
          }
          success
        }
      }
    }
}
fragment toteCartItemFields on ToteCartItem {
  id
  product {
    catalogue_photos {
      medium_url
    }
    category_rule {
      slug
      error_msg
      swap_ban_threshold
    }
    category {
      name
      accessory
    }
    id
    type
    swappable
    tote_slot
    disabled
  }
  product_size {
    id
    size_abbreviation
    size {
      id
      name
    }
    swappable
  }
  slot
}
`

const MUTATION_REMOVE_FROM_TOTE_CART = `
mutation removeFromToteCart($input: RemoveFromToteCartInput!) {
  RemoveFromToteCart(input: $input) {
    errors {
      error_code
      message
    }
    tote_cart {
      id
      state
      nth_tote        
      max_clothing_count
      max_accessory_count
      clothing_bonus_slots_sum
      accessory_bonus_slots_sum
      express_fulfillment_center_config {
        open_change_express
        popup_change_express_banner_url
        tips
      }
      accessory_items {
        ...toteCartItemFields
      }
      clothing_items {
        ...toteCartItemFields
      }
      premium_clothing_slot_count
      premium_accessory_slot_count
      premium_service {
        max_purchase_clothing_slot
        max_purchase_accessory_slot
        clothing_slot_price
        accessory_slot_price
        origin_clothing_slot_price
        origin_accessory_slot_price
      }
      has_replaced_product
      display_more_product_entry
      with_free_service
      used_free_service
      disable_free_service
      display_free_service_banner
      disable_coupon
      accessory_customer_coupon {
        customer_coupon_id
        slot_count
      }
      clothing_customer_coupon {
        customer_coupon_id
        slot_count
      }
      onboarding
      tote_cart_bottom_tips
      banner {
        url
      }
      popup {
        url
      }
      validate_result_v1(
        category_rule_flag: true
        need_category_rule_verify: true
      ) {
        errors {
          error_code
          message
        }
        success
      }
    }
  }
}
fragment toteCartItemFields on ToteCartItem {
  id
  product {
    category_rule {
      slug
      error_msg
      swap_ban_threshold
    }
    catalogue_photos {
      medium_url
    }
    category {
      name
      accessory
    }
    id
    type
    swappable
    tote_slot
    disabled
  }
  product_size {
    id
    size_abbreviation
    size {
      id
      name
    }
    swappable
  }
  slot
}
`

const MUTATION_ADD_TO_TOTE_CART = `
mutation addToToteCart($input: AddToToteCartInput!) {
  AddToToteCart(input: $input) {
    errors {
      error_code
      message
    }
    tote_cart {
      id
      state
      nth_tote        
      max_clothing_count
      max_accessory_count
      clothing_bonus_slots_sum
      accessory_bonus_slots_sum
      express_fulfillment_center_config {
        open_change_express
        popup_change_express_banner_url
        tips
      }
      accessory_items {
        ...toteCartItemFields
      }
      clothing_items {
        ...toteCartItemFields
      }
      premium_clothing_slot_count
      premium_accessory_slot_count
      premium_service {
        max_purchase_clothing_slot
        max_purchase_accessory_slot
        clothing_slot_price
        accessory_slot_price
        origin_clothing_slot_price
        origin_accessory_slot_price
      }
      has_replaced_product
      display_more_product_entry
      with_free_service
      used_free_service
      disable_free_service
      display_free_service_banner
      disable_coupon
      accessory_customer_coupon {
        customer_coupon_id
        slot_count
      }
      clothing_customer_coupon {
        customer_coupon_id
        slot_count
      }
      onboarding
      tote_cart_bottom_tips
      banner {
        url
      }
      popup {
        url
      }
      validate_result_v1(
        category_rule_flag: true
        need_category_rule_verify: true
      ) {
        errors {
          error_code
          message
        }
        success
      }
    }
  }
}
fragment toteCartItemFields on ToteCartItem {
  id
  product {
    catalogue_photos {
      medium_url
    }
    category_rule {
      slug
      error_msg
      swap_ban_threshold
    }
    category {
      name
      accessory
    }
    id
    type
    swappable
    tote_slot
    disabled
  }
  product_size {
    id
    size_abbreviation
    size {
      id
      name
    }
    swappable
  }
  slot
}
`

const MUTATION_REPLACE_FOR_TOTE_CART = `
mutation replaceForToteCart($input: ReplaceForToteCartInput!) {
  ReplaceForToteCart(input: $input) {
    errors {
      error_code
      message
    }
    tote_cart {
      id
      state
      nth_tote        
      max_clothing_count
      max_accessory_count
      clothing_bonus_slots_sum
      accessory_bonus_slots_sum
      express_fulfillment_center_config {
        open_change_express
        popup_change_express_banner_url
        tips
      }
      accessory_items {
        ...toteCartItemFields
      }
      clothing_items {
        ...toteCartItemFields
      }
      premium_clothing_slot_count
      premium_accessory_slot_count
      premium_service {
        max_purchase_clothing_slot
        max_purchase_accessory_slot
        clothing_slot_price
        accessory_slot_price
        origin_clothing_slot_price
        origin_accessory_slot_price
      }
      has_replaced_product
      display_more_product_entry
      with_free_service
      used_free_service
      disable_free_service
      display_free_service_banner
      disable_coupon
      accessory_customer_coupon {
        customer_coupon_id
        slot_count
      }
      clothing_customer_coupon {
        customer_coupon_id
        slot_count
      }
      onboarding
      tote_cart_bottom_tips
      banner {
        url
      }
      popup {
        url
      }
      validate_result_v1(
        category_rule_flag: true
        need_category_rule_verify: true
      ) {
        errors {
          error_code
          message
        }
        success
      }
    }
  }
}
fragment toteCartItemFields on ToteCartItem {
  id
  product {
    catalogue_photos {
      medium_url
    }
    category_rule {
      slug
      error_msg
      swap_ban_threshold
    }
    category {
      name
      accessory
    }
    id
    type
    swappable
    tote_slot
    disabled
  }
  product_size {
    id
    size_abbreviation
    size {
      id
      name
    }
    swappable
  }
  slot
}
`

const MUTATION_ADD_TOTE_CART_SLOT = `
mutation addToteCartSlot($input: AddToteCartSlotInput!) {
  AddToteCartSlot(input: $input) {
    errors {
      error_code
      message
    }
    tote_cart {
      id
      state
      nth_tote
      max_clothing_count
      max_accessory_count
      clothing_bonus_slots_sum
      accessory_bonus_slots_sum
      express_fulfillment_center_config {
        open_change_express
        popup_change_express_banner_url
        tips
      }
      accessory_items {
        ...toteCartItemFields
      }
      clothing_items {
        ...toteCartItemFields
      }
      premium_clothing_slot_count
      premium_accessory_slot_count
      premium_service {
        max_purchase_clothing_slot
        max_purchase_accessory_slot
        clothing_slot_price
        accessory_slot_price
        origin_clothing_slot_price
        origin_accessory_slot_price
      }
      has_replaced_product
      display_more_product_entry
      with_free_service
      used_free_service
      disable_free_service
      display_free_service_banner
      disable_coupon
      accessory_customer_coupon {
        customer_coupon_id
        slot_count
      }
      clothing_customer_coupon {
        customer_coupon_id
        slot_count
      }
      onboarding
      tote_cart_bottom_tips
      banner {
        url
      }
      popup {
        url
      }
      validate_result_v1(category_rule_flag: true, need_category_rule_verify: true) {
        errors {
          error_code
          message
        }
        success
      }
    }
  }
}

fragment toteCartItemFields on ToteCartItem {
  id
  product {
    catalogue_photos {
      medium_url
    }
    category_rule {
      slug
      error_msg
      swap_ban_threshold
    }
    category {
      name
      accessory
    }
    id
    type
    swappable
    tote_slot
    disabled
  }
  product_size {
    id
    size_abbreviation
    size {
      id
      name
    }
    swappable
  }
  slot
}
`

const MUTATION_REMOVE_TOTE_CART_SLOT = `
mutation removeToteCartSlot($input: RemoveToteCartSlotInput!) {
  RemoveToteCartSlot(input: $input) {
    errors {
      error_code
      message
    }
    tote_cart {
      id
      state
      nth_tote
      max_clothing_count
      max_accessory_count
      clothing_bonus_slots_sum
      accessory_bonus_slots_sum
      express_fulfillment_center_config {
        open_change_express
        popup_change_express_banner_url
        tips
      }
      accessory_items {
        ...toteCartItemFields
      }
      clothing_items {
        ...toteCartItemFields
      }
      premium_clothing_slot_count
      premium_accessory_slot_count
      premium_service {
        max_purchase_clothing_slot
        max_purchase_accessory_slot
        clothing_slot_price
        accessory_slot_price
        origin_clothing_slot_price
        origin_accessory_slot_price
      }
      has_replaced_product
      display_more_product_entry
      with_free_service
      used_free_service
      disable_free_service
      display_free_service_banner
      disable_coupon
      accessory_customer_coupon {
        customer_coupon_id
        slot_count
      }
      clothing_customer_coupon {
        customer_coupon_id
        slot_count
      }
      onboarding
      tote_cart_bottom_tips
      banner {
        url
      }
      popup {
        url
      }
      validate_result_v1(category_rule_flag: true, need_category_rule_verify: true) {
        errors {
          error_code
          message
        }
        success
      }
    }
  }
}

fragment toteCartItemFields on ToteCartItem {
  id
  product {
    catalogue_photos {
      medium_url
    }
    category_rule {
      slug
      error_msg
      swap_ban_threshold
    }
    category {
      name
      accessory
    }
    id
    type
    swappable
    tote_slot
    disabled
  }
  product_size {
    id
    size_abbreviation
    size {
      id
      name
    }
    swappable
  }
  slot
}
`

const QUERY_EXPRESS = `
  query express($shipping_address: ShippingAddressInput!) {
    me {
      id
      tote_cart {
        id
        deliver_express_data(shipping_address: $shipping_address) {
          default_select_id
          show_express_group_title
          express_groups {
            title
            subscription_type_express_types {
              id
              disabled
              tips
              express_code
              express_title
              original_express_title
              express_type {
                id
                name
                express_company {
                  id
                }
              }
              btn_tags {
                title
                title_color
                bg_color
                border_color
              }
            }
          }
        }
      }
    }
  }
`

const QUERY_EXPRESS_DURATION = `
  query expressDuration(
    $express_company_id: ID!
    $shipping_address: ShippingAddressInput!
  ) {
    predict_express_duration(
      express_company_id: $express_company_id
      shipping_address: $shipping_address
    ) {
      id
      name
      predict_duration
      predict_date_time
      title
      shipping_way
    }
  }
`

const QUERY_PREVIEW_TOTE_PREMIUM_SERVICE_FEE = `
 query preview(
    $subscription_type_express_type_id: ID
    $shipping_address: ShippingAddressInput
  ) {
    me {
      credit_account {
        balance
      }
    }
    preview_tote_premium_service_fee_v1(
      subscription_type_express_type_id: $subscription_type_express_type_id
      shipping_address: $shipping_address
    ) {
      clothing_slot_count # 衣位数量
      clothing_slot_price # 加购衣位的价格
      accessory_slot_count # 配饰位数量
      accessory_slot_price # 加购衣位的价格
      cash_price # 使用多少奖励金
      final_price # 实付金额
      shipping_fee
    }
    needs_payment_tote_premium_service_fee {
      id
      summary {
        total_amount
        purchase_credit
        shipping_cost
      }
      expected_cancel_at
      transaction_premium_service {
        clothing_slot_count
        clothing_slot_price
        accessory_slot_count
        accessory_slot_price
      }
      subscription_type_express_type {
        id
        disabled
        tips
        express_code
        express_title
        original_express_title
        express_type {
          id
          name
          express_company {
            id
          }
        }
        btn_tags {
          title
          title_color
          bg_color
          border_color
        }
      }
    }
  }
`

const MUTATION_CANCEL_ORDER = `
  mutation WebCancelOrder($input: CancelOrderInput!) {
    CancelOrder(input: $input) {
      order {
        id
      }
      success
    }
  }
`

const QUERY_PLACE_ORDER = `
  query WebPlaceOrder($id: ID) {
    order(id: $id) {
      successful
      tote {
        id
        is_first_tote
        first_locked_at
        tote_swap_questionnaire {
          options {
            key
            value
          }
          theme_question
          improvement_question
        }
        can_free_purchase
        free_purchase_type {
          abort_part_one
          abort_part_one_image_url
          abort_part_two
          abort_part_two_image_url
          clothing_slot_count
          accessory_slot_count
          play_description_text
        }
      }
    }
  }
`

const QUERY_NEEDS_PAYMENT_TOTE_PREMIUM_SERVICE = `
  query WebNeedsPaymentTotePremiumService {
    needs_payment_tote_premium_service_fee {
      id
    }
  }
`

export {
  QUERY_TOTE_CART,
  MUTATION_REMOVE_FROM_TOTE_CART,
  MUTATION_ADD_TO_TOTE_CART,
  MUTATION_REPLACE_FOR_TOTE_CART,
  MUTATION_ADD_TOTE_CART_SLOT,
  MUTATION_REMOVE_TOTE_CART_SLOT,
  QUERY_PREVIEW_TOTE_PREMIUM_SERVICE_FEE,
  QUERY_EXPRESS,
  QUERY_EXPRESS_DURATION,
  MUTATION_CANCEL_ORDER,
  QUERY_PLACE_ORDER,
  QUERY_NEEDS_PAYMENT_TOTE_PREMIUM_SERVICE
}
